import { ModelService } from '@philips-internal/oswald-ui-core/lib/services';
export function formatCurrency(value) {
    if (value === undefined || value === null)
        return '';
    const numValue = Number(value);
    if (isNaN(numValue))
        return '';
    return ModelService.format('currency', numValue, {});
}
//# sourceMappingURL=format-currency.js.map